import { RequestPriority } from '@app/core/interceptors/queue-requests-interceptor/enums/request-priority.enum';
import { IRequestPrioritySlotsConfig } from '@app/core/interceptors/queue-requests-interceptor/interfaces/request-priority-slots-config.interface';

/** The backend allows only this many simultaneous requests per client. */
export const MAX_CONCURRENT_REQUESTS = 4;

/**
 * How each {@link RequestPriority} shares the global http queue of {@link MAX_CONCURRENT_REQUESTS} slots
 * (see `http-queue.service.ts`). Internal to the queue.
 */
export const REQUEST_PRIORITY_SLOTS_CONFIG: Record<RequestPriority, IRequestPrioritySlotsConfig> = {
  [RequestPriority.High]: { maxSlots: MAX_CONCURRENT_REQUESTS, guaranteedSlots: MAX_CONCURRENT_REQUESTS },
  [RequestPriority.Medium]: { maxSlots: MAX_CONCURRENT_REQUESTS - 1, guaranteedSlots: 1 },
  // more would block the next page's requests after a navigation
  [RequestPriority.Low]: { maxSlots: MAX_CONCURRENT_REQUESTS - 1, guaranteedSlots: 0 },
};
